<mat-icon *ngIf="!isIE11 && !color" [ngClass]="[iconClass || '', iconFillClass]">{{icon}}</mat-icon>
<mat-icon *ngIf="!isIE11 && color" [color]="iconClass" [ngClass]="[iconClass || '', iconFillClass]">{{icon}}</mat-icon>

<span *ngIf="isIE11 && !color" [ngClass]="['cqes-icon', 'mat-icon']"><img src="../../../../assets/images/svg-icons/{{iconName}}.svg"></span>
<span *ngIf="isIE11 && color" [ngClass]="['cqes-icon', 'mat-icon']"><img src="../../../../assets/images/svg-icons/stepper/{{iconName}}.svg"></span>


